import React from 'react';
import { SupplierDirectory } from '../components/sections/SupplierDirectory';
import { SectionHeading } from '../components/ui/SectionHeading';
import { useLang } from '../lib/i18n/LanguageContext';
import { dictionary } from '../lib/i18n/dictionary';
export function SuppliersPage() {
  const {
    lang
  } = useLang();
  const t = dictionary.directory;
  return <main className="pt-32 pb-24 bg-white min-h-screen" data-id="element-878">
      <div className="max-w-7xl mx-auto px-5 md:px-8 mb-10" data-id="element-879">
        <SectionHeading eyebrow={t.eyebrow[lang]} title={t.title[lang]} subtitle={t.subtitle[lang]} data-id="element-880" />
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-881">
        <SupplierDirectory showHeader={false} embedded data-id="element-882" />
      </div>
    </main>;
}